module.exports = __webpack_public_path__ + "static/media/mis-cursos-fill.179b94cd.svg";